var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakerSperation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 299.33 215.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#d1ebff;}.cls-3,.cls-7{fill:#084c94;}.cls-4{fill:#eb4680;}.cls-14,.cls-5{fill:#a8cff0;}.cls-10,.cls-6{fill:#2672ab;}.cls-10,.cls-7{opacity:0.5;}.cls-8{fill:#3f92d1;}.cls-9{fill:#72b5e8;}.cls-11{fill:#0fbab8;}.cls-12{fill:#f0f8ff;}.cls-13,.cls-14,.cls-18,.cls-19{mix-blend-mode:multiply;}.cls-13{fill:url(#linear-gradient);}.cls-15{fill:#fff;}.cls-16{fill:#3ecfcd;}.cls-17{fill:#0ba19f;}.cls-18{fill:url(#linear-gradient-2);}.cls-19{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9783.84,
    y1: 155.28,
    x2: 9783.28,
    y2: 166.12,
    gradientTransform: "matrix(-1, 0, 0, 1, 10111.86, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 9372.12,
    y1: 143.87,
    x2: 9371.56,
    y2: 154.71,
    gradientTransform: "translate(-9260.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 9878.91,
    y1: 93.17,
    x2: 9878.35,
    y2: 104.02,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.89,172.1c.37.07,1.09.14,1,1.57a23,23,0,0,0,.14,4.87c.09.65.55,1.17.36,1.53s-.73.12-.89-.23a6.63,6.63,0,0,1-.33-1,6.18,6.18,0,0,0,.24,1.93c.25.39.73.83.45,1.22s-1-.32-1.17-.77a4.49,4.49,0,0,1-.28-1,8.9,8.9,0,0,0,.26,1.84c.14.52.78,1.23.53,1.46s-.73,0-1.06-.61a2.76,2.76,0,0,1-.25-.58,6.1,6.1,0,0,1,.12,1.57c-.11.2-.61.4-.83-.32a46.88,46.88,0,0,1-1.15-7.87,6.79,6.79,0,0,1,.62-2.95C314.92,172.2,315.94,171.91,316.89,172.1Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.36,155.36l-17.06,9.8c-1.63.94-.63,2.6,1.68,2.69h.13l-1.81,1c-1.63.95-.63,2.61,1.68,2.7.41,0,.82,31.24,1.22,31.28l14.18-8.12h.05v-39.4Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M265,197.42l.1-.06H265S265,197.38,265,197.42Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.36,181.11l-17.06,9.8c-1.63.94-.63,2.6,1.68,2.69h.13l-1.81,1a1.42,1.42,0,0,0-.8,1,1.39,1.39,0,0,1,.8-1l17.06-9.8h.07V181.1Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.75,199.1a8,8,0,0,1,3.26,3.8c.53-1.34.57-34,.13-35.31.91-2.78-.23-5.85-3.39-7.89-6-3.89-16.35-4-22.61-.42-2.65,1.53-4.13,3.47-4.45,5.47-.17,1-2.32,1.5-3.6.76L174.27,156v39.4l16.82,9.51c1.28.74,3.43.28,3.6-.76.32-2,1.8-3.94,4.45-5.47C205.4,195.07,215.72,195.21,221.75,199.1Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M194.69,204.15c.32-2,1.8-3.94,4.45-5.47,6.26-3.61,16.58-3.47,22.61.42a8,8,0,0,1,3.26,3.8c.53-1.34.57-34,.13-35.31.91-2.78-.23-5.85-3.39-7.89-6-3.89-16.35-4-22.61-.42-2.65,1.53-4.13,3.47-4.45,5.47Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M194.69,194.25c.32-2,1.8-3.94,4.45-5.47,6.26-3.61,16.58-3.47,22.61.42a7.86,7.86,0,0,1,3.42,4.3,1.16,1.16,0,0,0,0-.16c.91-2.78-.23-5.85-3.39-7.89-6-3.89-16.35-4-22.61-.42-2.65,1.53-4.13,3.47-4.45,5.47-.17,1-2.32,1.5-3.6.76l-16.82-9.51v3.75L191.09,195C192.37,195.75,194.52,195.29,194.69,194.25Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.32,185.92l-16.9-9.25a1.32,1.32,0,0,1-.48-.45v38.55c-.28.42-.18.92.48,1.3l16.9,9.25Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M227.32,225.32l17.25-9.95c1.63-.94,4.48-.35,4.63,1,.25,2.11,1.84,4.18,4.77,5.75,5.64,3,14.61,3,20.22,0,3-1.62,4.6-3.78,4.73-6H279v-39.4h-.07c-.14,2.19-1.71,4.35-4.73,6-5.61,3-14.58,3-20.22,0-2.93-1.57-4.52-3.64-4.77-5.75-.15-1.34-3-1.93-4.63-1l-17.25,9.95Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.94,240.52a.74.74,0,0,0,0,.85Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M210.42,202.82a1.32,1.32,0,0,1-.48-.45v3.35a1.32,1.32,0,0,0,.48.45l16.9,9.26v-3.36Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.92,202.54a8.42,8.42,0,0,1-4.73,6.46c-5.61,3-14.58,3-20.22,0-2.93-1.57-4.52-3.64-4.77-5.75-.15-1.34-3-1.93-4.63-1l-17.25,10v3.25l17.25-10c1.63-.94,4.48-.35,4.63,1,.25,2.11,1.84,4.18,4.77,5.75,5.64,3,14.61,3,20.22,0,3-1.61,4.59-3.77,4.73-6H279V203Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M199.14,159.28c6.26-3.61,16.58-3.47,22.61.42,4.87,3.14,5,8.74.12,11.91a20.91,20.91,0,0,1-10.11,3c-1.81.1-2.64,1.33-1.34,2.08l16.9,9.25L244.57,176c1.63-.94,4.48-.35,4.63,1,.25,2.11,1.84,4.18,4.77,5.75,5.64,3,14.61,3,20.22,0,6.22-3.32,6.33-8.94.36-12.38a21.07,21.07,0,0,0-9.57-2.52c-2.31-.09-3.31-1.75-1.68-2.69l17.08-9.8-47.47-26.7a11.13,11.13,0,0,0-11.16,0L174.27,156l16.82,9.51c1.28.74,3.43.28,3.6-.76C195,162.75,196.49,160.81,199.14,159.28Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M221.75,159.7a7.43,7.43,0,0,1,3.66,5.47c.26-2.41-1-4.9-3.66-6.64-6-3.89-16.35-4-22.61-.41-2.65,1.52-4.13,3.47-4.45,5.46-.17,1-2.32,1.51-3.6.77l-15.79-8.93-1,.58,16.82,9.51c1.28.74,3.43.28,3.6-.76.32-2,1.8-3.94,4.45-5.47C205.4,155.67,215.72,155.81,221.75,159.7Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M274.19,181.59c-5.61,3-14.58,3-20.22-.05-2.93-1.57-4.52-3.64-4.77-5.75-.15-1.33-3-1.93-4.63-1l-17.25,10-16.9-9.26a1.25,1.25,0,0,1-.35-.27c-.42.45-.38,1,.35,1.44l16.9,9.26,17.25-10c1.63-.94,4.48-.35,4.63,1,.25,2.11,1.84,4.18,4.77,5.75,5.64,3,14.61,3,20.22,0,3.46-1.84,5-4.4,4.7-6.9C278.67,178,277.11,180,274.19,181.59Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M263.3,164c-.84.48-1,1.15-.61,1.7a1.81,1.81,0,0,1,.61-.53l17.08-9.8-1-.58Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M159.77,232.79a19.84,19.84,0,0,0,8.66-2.64c2.79-1.73,4.06-4,3.86-6.27h.1v-39.4l-.1,0c.19,2.25-1.09,4.52-3.86,6.24a20.54,20.54,0,0,1-9.93,2.72c-2.31.08-3.32,1.72-1.68,2.67l1.85,1.07h-.17C156.19,197.3,159.77,232.79,159.77,232.79Zm12.52-43.86v.19a1.2,1.2,0,0,1,0-.19Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.4,217.24c-1.29.74-3.43.25-3.61-.79-.39-2.17-2.13-4.27-5.23-5.86-5.59-2.86-14.84-2.9-20.45-.09-4.46,2.23-6.11,5.56-5,8.62-.5,1.35-.45,34,.14,35.31a9.9,9.9,0,0,1,4.85-4.53c5.61-2.81,14.86-2.77,20.45.09,3.1,1.59,4.84,3.69,5.23,5.86.18,1,2.32,1.53,3.61.79l18-10.61v-39.4Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M153.79,216.45c-.39-2.17-2.13-4.27-5.23-5.86-5.59-2.86-14.84-2.9-20.45-.09-4.46,2.23-6.11,5.56-5,8.62-.5,1.35-.45,34,.14,35.31a9.9,9.9,0,0,1,4.85-4.53c5.61-2.81,14.86-2.77,20.45.09,3.1,1.59,4.84,3.69,5.23,5.86Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M123.12,241.12a5.31,5.31,0,0,1-.19-.65c-.11,3.2-.16,8.86-.15,14.6C122.8,248,122.91,241.7,123.12,241.12Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M157.4,238c-1.29.74-3.43.25-3.61-.79-.39-2.17-2.13-4.27-5.23-5.86-5.59-2.86-14.84-2.9-20.45-.09-4.33,2.17-6,5.37-5.07,8.36.61-1.91,2.3-3.72,5.07-5.11,5.61-2.81,14.86-2.77,20.45.09,3.1,1.59,4.84,3.69,5.23,5.86.18,1,2.32,1.53,3.61.79l18-10.61v-3.25Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.87,277.23h0l16.31-9.51c.5-.28.67-.64.6-1V227.54a1,1,0,0,1-.6.78l-16.31,9.51h0Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121.87,237.83h0l16.31-9.51c1.28-.73.46-2-1.34-2.08a21.77,21.77,0,0,1-9.5-2.6c-6.35-3.67-6.11-9.7.76-13.14,5.61-2.81,14.86-2.77,20.45.09,3.1,1.59,4.84,3.69,5.23,5.86.18,1,2.32,1.53,3.61.79l18-10.61-18.62-10.49c-1.64-.95-.63-2.59,1.68-2.67a20.54,20.54,0,0,0,9.93-2.72c5.21-3.23,5.19-8.42-.05-11.68-5.79-3.6-15.52-3.7-21.46-.28-2.65,1.53-4.08,3.5-4.29,5.51-.14,1.33-3,1.9-4.66,1l-16.61-9.43h0L67.79,207h0Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M168.43,189.52a20.53,20.53,0,0,1-9.93,2.71c-1.94.07-3,1.24-2.27,2.17a2.93,2.93,0,0,1,2.27-.93,20.54,20.54,0,0,0,9.93-2.72c2.85-1.77,4.12-4.11,3.84-6.41C172,186.22,170.77,188.07,168.43,189.52Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M157.4,216c-1.29.74-3.43.26-3.61-.79-.39-2.16-2.13-4.27-5.23-5.85-5.59-2.86-14.84-2.9-20.45-.1-3.88,2-5.65,4.73-5.3,7.43.25-2.29,2-4.54,5.3-6.19,5.61-2.81,14.86-2.77,20.45.09,3.1,1.59,4.84,3.69,5.23,5.86.18,1,2.32,1.53,3.61.79l18-10.61-1.07-.6Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.19,227.09l-16.31,9.51h0l-53-30.2-1.07.62h0l54.08,30.8h0l16.31-9.51c.74-.42.76-1,.31-1.46A1.56,1.56,0,0,1,138.19,227.09Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "54.09 167.74 54.09 207.15 0.01 176.34 0.01 136.94 54.09 167.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M138.79,285.76a.66.66,0,0,0,0-.28Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M138.19,252.32a1,1,0,0,0,.6-.78v-3.25a1,1,0,0,1-.6.78l-16.31,9.51h0v3.25h0Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "0.01 157.69 0.01 160.94 54.09 191.74 54.09 188.49 0.01 157.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.67,222.57l-1.85-1.07.17,0c2.31-.08,3.33-1.72,1.68-2.66L261,208.71h0v39.4l14.74,8.4c.42,0,.84-31.26,1.26-31.28C279.3,225.15,280.32,223.51,278.67,222.57Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.82,251.75l.1.05s0,0,0-.06Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.67,249.82l-1.85-1.07H277c2.31-.09,3.33-1.73,1.68-1.87L261,236.76V240h0l17.68,10.11a1.41,1.41,0,0,1,.8,1A1.27,1.27,0,0,0,278.67,249.82Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.62,193a21.73,21.73,0,0,0-9.5-2.61c-1.15-.06-1.89-.6-1.94-1.17h0v39.4h0c0,.57.78,1.12,1.94,1.18a21.73,21.73,0,0,1,9.5,2.61,9.41,9.41,0,0,1,4.1,4.16c.59-1.35.63-34,.13-35.32C312.91,198.39,311.51,195.26,307.62,193Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "299.29 139.15 246.5 169.05 246.5 208.45 299.29 178.54 299.29 139.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.52,229.7c-1.64-.95-4.51-.38-4.66,1-.21,2-1.64,4-4.29,5.51-5.93,3.42-15.67,3.33-21.46-.28-2.56-1.6-3.87-3.65-3.93-5.72h0v39.4h0c.06,2.07,1.36,4.13,3.93,5.73,5.79,3.61,15.53,3.7,21.46.28,2.65-1.53,4.08-3.5,4.29-5.51.15-1.33,3-1.9,4.66-.95l16.77,9.43v-39.4Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M292.86,230.65c-.21,2-1.64,4-4.29,5.51-5.93,3.42-15.67,3.33-21.46-.28-2.56-1.6-3.87-3.65-3.93-5.72h0v39.4h0c.06,2.07,1.36,4.13,3.93,5.73,5.79,3.61,15.53,3.7,21.46.28,2.65-1.53,4.08-3.5,4.29-5.51Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.29,267.18l-16.77-9.43c-1.64-.95-4.51-.38-4.66.95-.21,2-1.64,4-4.29,5.51-5.93,3.42-15.67,3.33-21.46-.28-2.56-1.6-3.87-3.65-3.93-5.72h0v3.2h0c.06,2.07,1.37,4.12,3.93,5.72,5.79,3.61,15.53,3.7,21.46.28,2.65-1.53,4.08-3.5,4.29-5.51.15-1.33,3-1.9,4.66-.95l16.77,9.43,52.78-29.9v-3.2Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M367.12,209.24l-53.3-30.42-17,9.51c-1.27.74-.45,2,1.34,2.08a21.73,21.73,0,0,1,9.5,2.61c6.36,3.67,6.12,9.7-.76,13.14-5.61,2.81-14.85,2.76-20.45-.1-3.09-1.58-4.84-3.68-5.22-5.85-.18-1-2.33-1.53-3.61-.79L261,208.71l17.68,10.11c1.65.94.63,2.58-1.68,2.67a20.42,20.42,0,0,0-9.93,2.71c-5.21,3.24-5.18,8.42.05,11.68,5.79,3.61,15.53,3.7,21.46.28,2.65-1.53,4.08-3.5,4.29-5.51.15-1.33,3-1.9,4.66-1l16.77,9.43Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M298.12,190.41a21.73,21.73,0,0,1,9.5,2.61c2.77,1.59,4.28,3.64,4.55,5.72.25-2.48-1.25-5-4.55-6.92a21.73,21.73,0,0,0-9.5-2.61,2.52,2.52,0,0,1-1.66-.63C295.7,189.32,296.52,190.32,298.12,190.41Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M314.29,237.93l-16.77-9.43c-1.64-.95-4.51-.38-4.66.95-.21,2-1.64,4-4.29,5.51-5.93,3.42-15.67,3.33-21.46-.28-2.38-1.49-3.67-3.37-3.89-5.28-.28,2.31,1,4.68,3.89,6.48,5.79,3.61,15.53,3.7,21.46.28,2.65-1.53,4.08-3.5,4.29-5.51.15-1.33,3-1.9,4.66-1l16.77,9.43,52.83-29.89-1.06-.6Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M279.27,219.33c.39-.55.26-1.22-.6-1.71l-16.62-9.5-1.06.59,17.68,10.11A1.73,1.73,0,0,1,279.27,219.33Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.44,181.7c.65.16.88.17.92.9a25.25,25.25,0,0,1,0,4.07,21.37,21.37,0,0,1-1.36,5c-.35.47-.62.32-.73.2s0-.5,0-.77c.11-.76.22-1.84.22-1.84s-.52,2-.66,2.61-.48,1.22-.86,1.25-.52-.2-.45-.48a11.71,11.71,0,0,0,.25-1.31c0-.4.13-1.47.13-1.47a19.34,19.34,0,0,1-.61,2.59c-.14.4-.57,1.82-1.24,1.45-.41-.23,0-1.19.22-2.05a18.5,18.5,0,0,0,.45-4.46c-.14-.86-.38-1.23-1.29-.58s-1.72,1.28-1.9.86.52-1.42,1.07-1.94,1.37-1.08,2-1.56c1.23-1,1.44-2.23,2-2.5A2.51,2.51,0,0,1,339.44,181.7Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M336.06,192.4l0,.1c-.36,1.07-.61,1.23-.73,1.23l-.09,0c-.11-.06.07-.72.16-1s.14-.48.19-.72a19.07,19.07,0,0,0,.46-4.56c-.07-.4-.17-1.06-.75-1.06a1.49,1.49,0,0,0-1,.3l-.26.19a4.46,4.46,0,0,1-1.27.76,3.36,3.36,0,0,1,1-1.62c.62-.59,1.51-1.18,2-1.54a5.9,5.9,0,0,0,1.41-1.77c.2-.33.16,0,1,.63a2.81,2.81,0,0,0,1,.3,23.46,23.46,0,0,1-1,2.5A44.9,44.9,0,0,0,336.06,192.4Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.56,181.81a1.4,1.4,0,1,0,1.52-1.28A1.4,1.4,0,0,0,337.56,181.81Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.28,165.1s.8,0,1.24,1.37-.62,12.27-.8,13.36-.37,2.44-1.71,2.39a1.48,1.48,0,0,1-1.61-1.64c.05-1,.13-6.27-.11-9.44-.21-2.92-.24-3.83.18-4.79A2.32,2.32,0,0,1,340.28,165.1Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M339.11,167.85c.87.1.91.18.93,1.19,0,2.28-.37,9.17-.51,10.09s-.2,2.46-1,2.35c-.56-.06-.55-1.17-.56-1.82,0-1.32,0-5-.07-7.64-.1-2.45-.28-3.61,0-4.12C338.07,167.61,338.46,167.77,339.11,167.85Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M337.78,166.05a1.6,1.6,0,1,0,1.21-1.92A1.62,1.62,0,0,0,337.78,166.05Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341,163.79c0,1.25-.29,1.79-1.72,2.13-1,.23-1.78,0-2-.82-.52-1.64-1.12-4.13-1.63-5.57-.56-1.59-1.43-2.68-.75-3.55s3.14-2.61,4.22-2.08S340.94,162.78,341,163.79Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M339.21,163.54c.12.8.21,1.67-.34,1.85a1,1,0,0,1-1.26-.76c-.19-.74-1-3.73-1.45-5s-1.05-2.65-.76-3.36,1.19-1.55,1.91-1.13S339.12,162.93,339.21,163.54Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M314.9,172.41A1.3,1.3,0,1,0,316,171,1.3,1.3,0,0,0,314.9,172.41Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.23,162.52c-.13,1.4-.84,4.45-1.12,5.95a19.3,19.3,0,0,0-.6,2.91c0,.85-.49,1.54-1.73,1.22s-1-1.49-1-2.51c0-2.38.19-8.74,1-10.77C316.3,158.18,319.54,158.89,319.23,162.52Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M317.14,163.3c-.13,1.2-.9,6.34-1,7.18s-.24,1.94-.67,1.52a3.16,3.16,0,0,1-.4-2.24,83,83,0,0,1,.95-8.89C316.17,160.43,317.47,160.19,317.14,163.3Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317,160.58a1.6,1.6,0,1,0-.64-2.18A1.62,1.62,0,0,0,317,160.58Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.78,151.08c.94.68,2.71-1.5,3.39-2.44a2.11,2.11,0,1,0-3.41-2.47C318.08,147.11,317.84,150.4,318.78,151.08Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.79,147.76c.68-.49,3.71,1.51,4,2.12s-.75,3.71-1.41,6c-.74,2.55-.88,3.3-1.92,3.43a1.8,1.8,0,0,1-2-.92C316,157,317,148.37,317.79,147.76Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M317.93,148.72a.92.92,0,0,1,1.48.35c.23.46-.35,3.08-.78,6.24-.32,2.4-.17,2.32-.57,2.89-.55.8-1.09.06-1.2-.33C316.56,156.76,317.25,149.41,317.93,148.72Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M325.83,206.32a2.4,2.4,0,0,1,1.59,2c.18,1.11.06,2.5-1.66,2.61A6.31,6.31,0,0,0,322,212c-1,.75-4.13,1.22-4.88.36s.33-1.44,1.24-2a13.29,13.29,0,0,0,3.35-2.67,3.19,3.19,0,0,1,1.95-1.35A3.89,3.89,0,0,1,325.83,206.32Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M327.42,208.28c0-.08,0-.16-.05-.24.11,1.05-.1,2.25-1.69,2.35a6.27,6.27,0,0,0-3.76,1.13c-1,.75-4.13,1.21-4.88.35a1.28,1.28,0,0,1-.14-.21.77.77,0,0,0,.23.71c.75.86,3.89.39,4.88-.36a6.31,6.31,0,0,1,3.75-1.12C327.48,210.78,327.6,209.39,327.42,208.28Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M324.53,207.75c1,.23,1.33-.21,1.46.61s.05,1.42-1.23,1.5a4.74,4.74,0,0,0-2.79.83c-.73.56-4,1.81-4.46,1.12-.35-.5,1.06-1.22,1.74-1.63a9.92,9.92,0,0,0,2.49-2,2.4,2.4,0,0,1,1.45-1C323.45,207.1,323.65,207.54,324.53,207.75Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M324,190.2c.45.76.62,2.52,1.06,4.64s1.43,5,1.28,7.73.46,4.28.07,4.7a1.58,1.58,0,0,1-1.88.16c-.66-.4-1.11-.69-.93-1.09s1-1.87.31-5.12-1.77-7.59-2.14-8-.82-.29-1.28-1S323.22,188.88,324,190.2Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.82,205.52c-.51.61-2.59.17-3-.27s-1.39-5.47-2.21-8.31c-.74-2.54-1.64-4.65-1.27-5.23s2-2.76,3.62-2,2,4.77,2.42,7.43S327.33,204.91,326.82,205.52Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M325.15,205c-.24.55-.81.33-1.06,0s-1.17-4.34-1.78-6.79c-.54-2.2-1.23-4.19-1.06-4.71.09-.3.43-.16,1.09-.28a.88.88,0,0,1,1,.67c.55,2.69.78,4,1.33,6.86C325.09,203,325.39,204.39,325.15,205Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.4,210.37a3.2,3.2,0,0,1,.75,3.16,11.27,11.27,0,0,1-2.18,3.73c-.86.81-2,2.05-3.82,1.37s-.16-3.43.39-4.13a7.35,7.35,0,0,0,1.42-2.85c.15-1,.57-1.15,1.08-1.19S332.89,209.79,333.4,210.37Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334,211.24a2.86,2.86,0,0,1,0,1.85,11.47,11.47,0,0,1-2.19,3.73c-.86.82-1.94,2.05-3.82,1.37a1.22,1.22,0,0,1-.64-.49,1.17,1.17,0,0,0,.82.93c1.87.68,3-.56,3.82-1.37a11.27,11.27,0,0,0,2.18-3.73A2.93,2.93,0,0,0,334,211.24Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M332.19,211.72c1-.08,1.11,0,1.25.32.25.52-.08.67-.3,1.25a11.33,11.33,0,0,1-1.91,2.94c-.94,1-1.79,1.84-2.94,1.52-1.36-.38.2-2.58.68-3.14a5.54,5.54,0,0,0,1.23-2.24c.14-.75.17-1,.62-1.06S331.16,211.81,332.19,211.72Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M332.2,195.32a16.48,16.48,0,0,1,1,5.38c.11,2.59-.05,6.43-.07,7.55a13,13,0,0,0,.2,2.1,1.2,1.2,0,0,1-1.52,1.11c-1-.31-1.59-.93-1.39-1.51a15.14,15.14,0,0,0,.51-6.31,27.2,27.2,0,0,0-1.22-6c-.22-.33-.75-.73-.93-1.17S331.25,192.87,332.2,195.32Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.61,208.5a1,1,0,0,1-.86,1,3,3,0,0,1-2.32-.45c-.44-.55-1.07-5.66-1.46-8-.34-2-1.26-4.13-.34-4.74s2.13-2.27,3.65-1.66c.9.36,1.44,4.86,1.46,9.26C333.75,205.75,333.66,207.57,333.61,208.5Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M331.93,208.57a.73.73,0,0,1-1.24,0c-.23-.44-.88-5.18-1.22-7.5-.22-1.58-.82-3.84-.19-3.59a5.93,5.93,0,0,0,1.56.39c.53.09.29,2.73.54,5.54C331.58,205.55,331.93,208.57,331.93,208.57Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320,190.61a2,2,0,1,0,2-2A2,2,0,0,0,320,190.61Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.83,189.06a2.48,2.48,0,0,1-2.36,2.36c-1.41,0-2.06-.63-2.24-2.36-.09-.94,1.06-19.72,1.77-21.67s2.71-4.06,5.36-2.88,2.71,4.36,1.53,7.12a55.76,55.76,0,0,0-2.94,10C324.59,183.82,323.83,187.82,323.83,189.06Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.42,173.81A5.93,5.93,0,0,1,322.3,169c-.26-1.51-.95-10-.95-10s9.95.47,10.54,1.12-.28,4.17,1.09,7.79C334.15,171,329.09,174.7,326.42,173.81Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M323.44,172.45a6,6,0,0,1-1.69-3.29c0-.19-.07-.48-.11-.84a13.28,13.28,0,0,0-.55,1.92c-.37,1.7-1.23,17.41-1.2,18.23s.14,2.05.87,2.05.72-2.6.72-3.47c0-1.08.4-4.58.58-6.53A76.44,76.44,0,0,1,323.44,172.45Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323.41,143.81c-1,0-3.26.12-3.91,1.62s.65,3.92.65,3.92-1.12,2.62-.68,4.47a7.53,7.53,0,0,1,.41,2.3c0,.18-1,3.09-.17,3.27a5.48,5.48,0,0,1,1.7.26c.62.3.94,1.1,2,1.83,1.27.85,6.14,3,7.44,3,3-.15,3.89-3.94,4.65-6.24.65-1.93,1.21-4.62,1.21-4.62s1.91-.3,1.86-1.62-1.67-2.42-3.2-3.71a25.71,25.71,0,0,0-4-2.95C327.89,143.55,325.24,143.87,323.41,143.81Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M323.75,144.22c-.91,0-3,.11-3.55,1.47a3.3,3.3,0,0,0,0,2,5.4,5.4,0,0,1-.18,3.18,6.71,6.71,0,0,0-.41,2,6.42,6.42,0,0,0,.41,2.45,22.22,22.22,0,0,0,4.4,2.2c3,.92,5.65-.16,6.46-2.2,1.53-3.85,4.09-3.57,4.56-4.74s.19-1.61-1.23-2.75A15.59,15.59,0,0,0,323.75,144.22Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M327.85,195a2,2,0,1,0,2-2A2,2,0,0,0,327.85,195Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.66,195a5,5,0,0,1-3.71.12,1.85,1.85,0,0,1-1.17-2.07,85.18,85.18,0,0,0,.46-10c-.12-4.65-1.09-8.34,0-11.13s3.7-4.88,6.05-4.17,2.9,3.29,2.66,6.17c-.27,3.35-3.9,13-4,15.9S332.39,194.54,331.66,195Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M329.63,194.19a1.07,1.07,0,0,1-1.72.35,1.73,1.73,0,0,1-.5-1.76c0-.31.47-5.3.4-9.77s-.66-7.29,0-10,2.36-4.71,3.85-4c1.17.54-.79,4.68-.94,7.44-.18,3.22-.75,10.3-.79,13.07S330,193.61,329.63,194.19Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329,133.16a3.53,3.53,0,0,1,1.5,4.68,10.22,10.22,0,0,0-.88,5.1,8,8,0,0,0,.91,2.54.61.61,0,0,1-.22.81,6,6,0,0,1-5.38.19.94.94,0,0,1-.42-1,11.21,11.21,0,0,0,.31-2.32C325,138.78,325.25,131.17,329,133.16Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.42,140.1a3.37,3.37,0,0,1-1.59,2.77c-1.18.8-3.27,2.33-4.62,1.59s-1.8-4.7-1.83-6.12c0-1.59.45-4.46,2.24-5.49a4.31,4.31,0,0,1,3.56-.46,5.65,5.65,0,0,1,2.3,1.5c.5.5,0,2-.27,3.06A12.41,12.41,0,0,0,329.42,140.1Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M323.24,143c-.8-.62-1.12-3.66-1.14-4.76s.32-3.35,1.33-4.29a2.4,2.4,0,0,1,2.42-.81c.6.21.37.87.21,1.35a19.18,19.18,0,0,0-.74,3.1C325.16,139,324.76,144.18,323.24,143Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M330.89,164.45c-1.3.06-6.17-2.12-7.44-3-1.1-.73-1.42-1.53-2-1.83a5.48,5.48,0,0,0-1.7-.26c-.8-.18.14-3.09.17-3.27a.13.13,0,0,0,0-.06h0V156h0a1.2,1.2,0,0,0,0-.24l.86.47a19.46,19.46,0,0,0,5.27,2.17c2.41.56,4.07.13,5.53-2.66,1-2,3.88-1.72,5.2-2.05h0c-.09.43-.61,2.8-1.19,4.54C334.78,160.51,333.92,164.3,330.89,164.45Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M323.24,158.79a28.05,28.05,0,0,1-3.57-1.87c.1-.42.2-.75.21-.8a1.23,1.23,0,0,0,0-.38l.86.47a19.46,19.46,0,0,0,5.27,2.17c2.41.56,4.3.17,5.75-2.62,1-2,3.66-1.76,5-2.09-.09.43-.61,2.8-1.19,4.54s-1.13,4-2.49,5.29a4.83,4.83,0,0,1-.2-1.63,7.84,7.84,0,0,0-.76-4.36S330.4,162.52,323.24,158.79Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.12,153a5.11,5.11,0,0,1-2.23.69c-.69,0-1.61.29-1.68.93s1,.93,1.31,3.84,1.44,1.67,2.25-.37S338.51,153.63,338.12,153Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M327,141.12c.26-2.14-.8-6,.82-7.06a1.71,1.71,0,0,1,1.72-.12c.43.54-.08,2-.31,3a12.41,12.41,0,0,0,.21,3.15,3.37,3.37,0,0,1-1.59,2.77,10,10,0,0,1-3.36,1.74A5.28,5.28,0,0,0,327,141.12Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M316.47,179.82a35.38,35.38,0,0,1,.55-3.66c.13-.34.61-.41.91-.51a14.61,14.61,0,0,1,0-2h0c.06-1.43-.43.16-1.59.16-1.39,0-1.32-.79-1.49-.39s.52,1.87.62,4.62a9.13,9.13,0,0,0,.12,2.07C315.74,180.47,316.38,180.32,316.47,179.82Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M327.82,141.24a2.77,2.77,0,0,1,1.25-2.16.94.94,0,0,1,.87-.11h0l.81.44-.09.16a1.32,1.32,0,0,1,.07.42,2.78,2.78,0,0,1-1.26,2.16,1.59,1.59,0,0,1-.4.16l-.1.15-.75-.4A.82.82,0,0,1,327.82,141.24Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M328.62,141.67c0,.79.56,1.11,1.25.71a2.77,2.77,0,0,0,1.25-2.16c0-.8-.56-1.12-1.25-.72A2.77,2.77,0,0,0,328.62,141.67Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M326.39,167a2.91,2.91,0,0,0-1.32-2.28.94.94,0,0,0-.91-.11h0l-.87.46.1.16a1.52,1.52,0,0,0-.07.45,2.9,2.9,0,0,0,1.33,2.28,1.42,1.42,0,0,0,.42.17l.1.16.8-.42A.9.9,0,0,0,326.39,167Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M325.58,167.47c0,.84-.59,1.18-1.32.76a2.91,2.91,0,0,1-1.33-2.29c0-.84.59-1.17,1.33-.75A2.91,2.91,0,0,1,325.58,167.47Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.55,167.49c0,.84-.59,1.18-1.32.75A2.92,2.92,0,0,1,322.9,166c0-.84.6-1.18,1.33-.75A2.91,2.91,0,0,1,325.55,167.49Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M325.14,167.25c0,.58-.41.81-.91.52a2,2,0,0,1-.91-1.57c0-.58.4-.81.91-.52A2,2,0,0,1,325.14,167.25Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M324.4,167.59a2,2,0,0,1-.91-1.57.83.83,0,0,1,.1-.41.62.62,0,0,0-.27.59,2,2,0,0,0,.91,1.57c.35.2.65.14.8-.11A.62.62,0,0,1,324.4,167.59Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M325.58,169.82a1.34,1.34,0,0,0-.63-1.07.44.44,0,0,0-.42-.06h0l-.41.22.05.08a.66.66,0,0,0,0,.21,1.36,1.36,0,0,0,.62,1.07.6.6,0,0,0,.2.07l0,.08.38-.2A.42.42,0,0,0,325.58,169.82Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M325.19,170c0,.39-.27.55-.62.35a1.35,1.35,0,0,1-.62-1.07c0-.39.28-.55.62-.35A1.36,1.36,0,0,1,325.19,170Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.18,170c0,.39-.28.55-.62.35a1.38,1.38,0,0,1-.62-1.07c0-.39.28-.55.62-.35A1.35,1.35,0,0,1,325.18,170Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123,160.69c-.36.07-1.08.13-1,1.56a23.13,23.13,0,0,1-.14,4.88c-.09.65-.55,1.16-.36,1.52s.73.13.89-.22a8.72,8.72,0,0,0,.33-1,6.27,6.27,0,0,1-.24,1.94c-.25.39-.73.82-.45,1.21s1-.32,1.17-.77a5.16,5.16,0,0,0,.28-1,9,9,0,0,1-.26,1.85c-.14.51-.78,1.23-.53,1.45s.73,0,1.06-.6a2.92,2.92,0,0,0,.25-.59,6.62,6.62,0,0,0-.13,1.58c.11.2.62.4.84-.32a47.23,47.23,0,0,0,1.15-7.87,6.81,6.81,0,0,0-.62-3C125,160.78,124,160.5,123,160.69Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.47,170.29c-.65.15-.88.17-.92.89a24.09,24.09,0,0,0,0,4.07,21.24,21.24,0,0,0,1.36,5c.35.48.62.32.72.21s0-.5,0-.77c-.11-.77-.22-1.85-.22-1.85l.66,2.61c.15.6.48,1.23.86,1.25s.51-.19.45-.48a9.41,9.41,0,0,1-.25-1.3c-.05-.41-.13-1.47-.13-1.47a19.34,19.34,0,0,0,.61,2.59c.14.39.57,1.81,1.24,1.44.41-.23,0-1.19-.22-2a18.59,18.59,0,0,1-.45-4.46c.13-.87.38-1.24,1.29-.59s1.72,1.29,1.9.86-.52-1.41-1.07-1.94-1.38-1.07-2-1.56c-1.23-1-1.44-2.22-2-2.5A2.5,2.5,0,0,0,100.47,170.29Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M103.85,181l0,.09c.36,1.08.61,1.24.73,1.24l.09,0c.11-.07-.08-.72-.17-1s-.13-.48-.18-.72a19,19,0,0,1-.46-4.56c.07-.39.17-1.06.75-1.06a1.57,1.57,0,0,1,1,.3l.26.19a4.46,4.46,0,0,0,1.27.76,3.41,3.41,0,0,0-1-1.62c-.62-.59-1.51-1.17-2-1.54a6,6,0,0,1-1.41-1.76c-.2-.34-.16,0-1,.62a2.6,2.6,0,0,1-1,.3,23.34,23.34,0,0,0,1,2.5A44,44,0,0,1,103.85,181Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.35,170.4a1.4,1.4,0,1,1-1.52-1.28A1.41,1.41,0,0,1,102.35,170.4Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.63,153.69s-.8,0-1.24,1.36.62,12.27.8,13.36.37,2.45,1.71,2.39a1.49,1.49,0,0,0,1.61-1.63c-.06-1-.13-6.28.1-9.44.22-2.93.25-3.84-.17-4.8A2.32,2.32,0,0,0,99.63,153.69Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M100.8,156.43c-.87.11-.91.19-.93,1.19-.05,2.28.37,9.17.5,10.09s.21,2.46,1,2.36c.56-.07.54-1.17.56-1.82,0-1.33,0-5,.07-7.64.1-2.45.28-3.61,0-4.12C101.84,156.2,101.45,156.35,100.8,156.43Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.12,154.64a1.59,1.59,0,0,1-1.91,1.2,1.6,1.6,0,1,1,.71-3.12A1.59,1.59,0,0,1,102.12,154.64Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99,152.38c0,1.24.29,1.79,1.72,2.12,1,.24,1.78,0,2-.82.52-1.64,1.12-4.13,1.63-5.56.56-1.59,1.43-2.68.75-3.56s-3.14-2.61-4.22-2.08S99,151.36,99,152.38Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M100.7,152.12c-.13.8-.21,1.68.34,1.85a1,1,0,0,0,1.26-.76c.19-.74,1-3.72,1.45-5s1-2.66.76-3.36-1.19-1.55-1.91-1.13S100.79,151.52,100.7,152.12Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125,161a1.29,1.29,0,0,1-1.44,1.13,1.31,1.31,0,0,1-1.13-1.45,1.3,1.3,0,0,1,1.45-1.12A1.28,1.28,0,0,1,125,161Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.68,151.1c.13,1.4.83,4.46,1.12,6a19.22,19.22,0,0,1,.6,2.9c0,.85.49,1.54,1.73,1.23s1-1.5,1-2.52c0-2.38-.19-8.74-1-10.77C123.61,146.76,120.37,147.47,120.68,151.1Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M122.77,151.88c.13,1.2.89,6.34,1,7.19s.24,1.93.67,1.52a3.2,3.2,0,0,0,.4-2.25,82.81,82.81,0,0,0-1-8.88C123.74,149,122.44,148.77,122.77,151.88Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.92,149.16a1.6,1.6,0,1,1-1.53-2.82,1.6,1.6,0,0,1,1.53,2.82Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.13,139.66c-.94.69-2.71-1.49-3.39-2.43a2.11,2.11,0,1,1,3.41-2.48C121.83,135.69,122.07,139,121.13,139.66Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.12,136.35c-.68-.5-3.71,1.51-4,2.11s.75,3.71,1.41,6c.74,2.55.88,3.31,1.91,3.43a1.81,1.81,0,0,0,2-.91C123.88,145.57,123,137,122.12,136.35Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M122,137.3a.92.92,0,0,0-1.48.36c-.23.45.35,3.08.78,6.23.32,2.4.17,2.33.57,2.9.55.79,1.09.05,1.19-.34C123.35,145.35,122.66,138,122,137.3Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.08,194.9a2.4,2.4,0,0,0-1.59,2c-.18,1.1-.07,2.49,1.66,2.6a6.31,6.31,0,0,1,3.75,1.13c1,.75,4.13,1.21,4.88.35s-.33-1.43-1.24-2a13.07,13.07,0,0,1-3.35-2.67,3.29,3.29,0,0,0-2-1.35A4,4,0,0,0,114.08,194.9Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.49,196.87a1.69,1.69,0,0,1,.05-.24c-.11,1.05.1,2.24,1.69,2.34A6.34,6.34,0,0,1,118,200.1c1,.75,4.13,1.21,4.88.35a1.86,1.86,0,0,0,.14-.2.78.78,0,0,1-.23.7c-.75.86-3.89.4-4.88-.35a6.31,6.31,0,0,0-3.75-1.13C112.42,199.36,112.31,198,112.49,196.87Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M115.38,196.33c-1,.23-1.33-.21-1.46.61s0,1.42,1.23,1.5a4.67,4.67,0,0,1,2.79.84c.73.56,4,1.81,4.46,1.12.35-.5-1.07-1.22-1.74-1.63a10,10,0,0,1-2.49-2,2.4,2.4,0,0,0-1.45-1C116.46,195.68,116.25,196.13,115.38,196.33Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.89,178.79c-.45.75-.62,2.52-1.06,4.64s-1.43,5-1.28,7.72-.46,4.29-.07,4.71a1.57,1.57,0,0,0,1.88.15c.66-.4,1.1-.68.93-1.08s-1-1.88-.31-5.12,1.76-7.6,2.14-8,.82-.28,1.28-1S116.69,177.46,115.89,178.79Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.09,194.1c.51.61,2.59.17,3-.27s1.39-5.47,2.21-8.31c.74-2.54,1.64-4.64,1.27-5.22s-2-2.76-3.62-2-2,4.77-2.42,7.43S112.58,193.49,113.09,194.1Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M114.76,193.53c.24.55.81.34,1.06,0s1.17-4.33,1.78-6.79c.54-2.2,1.23-4.19,1.06-4.71-.09-.3-.43-.16-1.09-.27a.87.87,0,0,0-1,.66c-.55,2.69-.78,4.06-1.33,6.86C114.82,191.54,114.52,193,114.76,193.53Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.51,199a3.2,3.2,0,0,0-.75,3.16,11.17,11.17,0,0,0,2.18,3.73c.86.82,1.94,2,3.82,1.37s.16-3.42-.4-4.13a7.48,7.48,0,0,1-1.41-2.85c-.15-.95-.57-1.14-1.08-1.19S107,198.38,106.51,199Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.94,199.82a2.86,2.86,0,0,0,0,1.85,11.27,11.27,0,0,0,2.19,3.73c.86.82,1.94,2.06,3.82,1.37a1.21,1.21,0,0,0,.64-.49,1.15,1.15,0,0,1-.82.93c-1.88.68-3-.55-3.82-1.37a11.17,11.17,0,0,1-2.18-3.73A2.93,2.93,0,0,1,105.94,199.82Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M107.72,200.31c-1-.09-1.11,0-1.25.31-.25.53.08.68.3,1.25a11.16,11.16,0,0,0,1.91,2.94c.94,1,1.78,1.84,2.93,1.52,1.37-.38-.19-2.58-.67-3.13A5.72,5.72,0,0,1,109.7,201c-.13-.75-.17-1-.61-1.06S108.75,200.4,107.72,200.31Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107.71,183.9a16.23,16.23,0,0,0-1,5.39c-.11,2.58,0,6.42.07,7.55a13.14,13.14,0,0,1-.2,2.1,1.19,1.19,0,0,0,1.52,1.1c1-.31,1.59-.93,1.39-1.5a15.22,15.22,0,0,1-.51-6.32,27.2,27.2,0,0,1,1.22-6c.22-.33.75-.73.93-1.17S108.66,181.45,107.71,183.9Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.3,197.09a1,1,0,0,0,.86,1,3,3,0,0,0,2.31-.46c.45-.55,1.08-5.66,1.47-8,.34-2,1.26-4.12.34-4.74s-2.13-2.26-3.65-1.65c-.9.36-1.45,4.85-1.46,9.26C106.16,194.33,106.25,196.15,106.3,197.09Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M108,197.16a.73.73,0,0,0,1.23,0c.24-.43.89-5.18,1.23-7.5.22-1.58.82-3.84.19-3.59a5.24,5.24,0,0,1-1.56.39c-.54.09-.29,2.73-.55,5.54C108.33,194.14,108,197.16,108,197.16Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.94,179.2a2,2,0,1,1-2-2A2,2,0,0,1,119.94,179.2Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.08,177.64a2.48,2.48,0,0,0,2.36,2.36c1.41,0,2.06-.62,2.23-2.36.1-.93-1.06-19.72-1.76-21.66s-2.71-4.06-5.36-2.89-2.71,4.36-1.53,7.13a55.29,55.29,0,0,1,2.94,9.95C115.32,172.4,116.08,176.41,116.08,177.64Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.49,162.4a6,6,0,0,0,4.12-4.77c.26-1.52.94-10,.94-10s-10,.47-10.53,1.12.28,4.16-1.09,7.78C105.76,159.6,110.82,163.28,113.49,162.4Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M116.47,161a6,6,0,0,0,1.69-3.29c0-.18.07-.47.11-.84a13.4,13.4,0,0,1,.55,1.93c.36,1.7,1.23,17.4,1.19,18.23s-.13,2.05-.86,2.05-.72-2.6-.72-3.48c0-1.08-.4-4.57-.58-6.53A77.31,77.31,0,0,0,116.47,161Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.49,132.4c1,0,3.27.12,3.92,1.62s-.65,3.91-.65,3.91,1.12,2.62.68,4.48a7.5,7.5,0,0,0-.41,2.29c0,.18,1,3.09.17,3.27a5.5,5.5,0,0,0-1.7.27c-.62.29-.94,1.09-2,1.83-1.27.85-6.14,3-7.44,3-3-.14-3.89-3.94-4.65-6.24-.65-1.93-1.21-4.62-1.21-4.62s-1.92-.29-1.86-1.62,1.67-2.41,3.2-3.71a25.52,25.52,0,0,1,4-2.94C112,132.14,114.67,132.46,116.49,132.4Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M116.16,132.81c.91,0,3,.1,3.55,1.46a3.31,3.31,0,0,1,0,2,5.36,5.36,0,0,0,.18,3.19,6.58,6.58,0,0,1,.41,1.94,6.44,6.44,0,0,1-.41,2.46,22.79,22.79,0,0,1-4.4,2.2c-3,.92-5.65-.17-6.46-2.21-1.53-3.85-4.09-3.56-4.56-4.73s-.19-1.61,1.23-2.75A15.48,15.48,0,0,1,116.16,132.81Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.06,183.55a2,2,0,1,1-2-2A2,2,0,0,1,112.06,183.55Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.25,183.63a5.11,5.11,0,0,0,3.71.12,1.87,1.87,0,0,0,1.17-2.07,85.5,85.5,0,0,1-.46-10c.11-4.65,1.09-8.34,0-11.13s-3.69-4.88-6-4.18-2.9,3.29-2.67,6.17c.28,3.35,3.91,13,4,15.91S107.52,183.13,108.25,183.63Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M110.28,182.77a1.06,1.06,0,0,0,1.71.35,1.71,1.71,0,0,0,.51-1.75c0-.31-.47-5.31-.4-9.77s.66-7.29,0-10-2.36-4.7-3.85-4c-1.17.55.79,4.68.94,7.45.18,3.22.75,10.29.79,13.06S109.94,182.19,110.28,182.77Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.9,121.74a3.54,3.54,0,0,0-1.5,4.68,10.24,10.24,0,0,1,.88,5.1,8,8,0,0,1-.91,2.54.61.61,0,0,0,.22.82,6,6,0,0,0,5.38.19.93.93,0,0,0,.41-1,11.22,11.22,0,0,1-.3-2.31C115,127.36,114.65,119.76,110.9,121.74Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.49,128.69a3.38,3.38,0,0,0,1.59,2.77c1.18.79,3.27,2.32,4.62,1.59s1.79-4.71,1.83-6.13c0-1.59-.45-4.46-2.25-5.49a4.23,4.23,0,0,0-3.55-.45,5.55,5.55,0,0,0-2.3,1.5c-.5.5,0,2,.26,3.06A12,12,0,0,1,110.49,128.69Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M116.67,131.59c.8-.63,1.12-3.66,1.13-4.77s-.31-3.35-1.32-4.28a2.4,2.4,0,0,0-2.42-.81c-.6.21-.37.87-.21,1.34a19.45,19.45,0,0,1,.74,3.1C114.75,127.57,115.15,132.77,116.67,131.59Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M109,153c1.3.07,6.17-2.11,7.44-3,1.1-.74,1.42-1.54,2-1.83a5.5,5.5,0,0,1,1.7-.27c.8-.18-.14-3.09-.17-3.27a.07.07,0,0,1,0,0h0v-.07h0a1.15,1.15,0,0,1,0-.24l-.86.46a19.46,19.46,0,0,1-5.27,2.17c-2.41.56-4.07.13-5.53-2.65-1-2-3.88-1.72-5.21-2.06h0c.1.44.61,2.8,1.2,4.54C105.13,149.09,106,152.89,109,153Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M116.67,147.37a26.93,26.93,0,0,0,3.57-1.86c-.11-.43-.2-.75-.21-.81a.92.92,0,0,1,0-.37l-.86.46a19.46,19.46,0,0,1-5.27,2.17c-2.41.56-4.3.17-5.76-2.62-1-2-3.65-1.75-5-2.09.1.44.61,2.8,1.2,4.54s1.12,4,2.49,5.29a4.73,4.73,0,0,0,.2-1.62,7.84,7.84,0,0,1,.76-4.36S109.51,151.11,116.67,147.37Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.79,141.62a5.11,5.11,0,0,0,2.23.69c.69,0,1.61.29,1.68.94s-1,.92-1.31,3.84-1.44,1.66-2.25-.37S101.4,142.21,101.79,141.62Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M112.93,129.7c-.26-2.14.8-6-.82-7.06a1.74,1.74,0,0,0-1.72-.12c-.43.54.08,2,.3,3a12,12,0,0,1-.2,3.15,3.38,3.38,0,0,0,1.59,2.77,10,10,0,0,0,3.36,1.73A5.23,5.23,0,0,1,112.93,129.7Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M123.43,168.4a32.25,32.25,0,0,0-.54-3.65c-.14-.35-.61-.41-.91-.52a14.61,14.61,0,0,0,0-2h0c-.06-1.43.43.17,1.59.17,1.39,0,1.32-.79,1.49-.4s-.53,1.87-.62,4.63a9.79,9.79,0,0,1-.12,2.07C124.17,169.05,123.52,168.9,123.43,168.4Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.09,129.82a2.77,2.77,0,0,0-1.25-2.16.91.91,0,0,0-.87-.1h0l-.81.44.09.15a1.32,1.32,0,0,0-.07.42,2.74,2.74,0,0,0,1.26,2.16,1.08,1.08,0,0,0,.4.16l.09.16.76-.4A.87.87,0,0,0,112.09,129.82Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.29,130.25c0,.79-.56,1.11-1.25.71a2.74,2.74,0,0,1-1.25-2.16c0-.79.56-1.11,1.25-.71A2.77,2.77,0,0,1,111.29,130.25Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M113.52,155.62a2.91,2.91,0,0,1,1.32-2.28,1,1,0,0,1,.91-.11h0l.86.46-.09.17a1.4,1.4,0,0,1,.07.44,2.92,2.92,0,0,1-1.33,2.28,1.17,1.17,0,0,1-.43.17l-.09.17-.8-.43A.88.88,0,0,1,113.52,155.62Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M114.33,156.06c0,.84.59,1.17,1.32.75a2.92,2.92,0,0,0,1.33-2.28c0-.84-.6-1.18-1.33-.76A2.94,2.94,0,0,0,114.33,156.06Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114.36,156.07c0,.84.59,1.18,1.32.76a2.93,2.93,0,0,0,1.33-2.29c0-.84-.6-1.17-1.33-.75A2.91,2.91,0,0,0,114.36,156.07Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M114.77,155.83c0,.58.41.81.91.52a2,2,0,0,0,.91-1.57c0-.57-.4-.81-.91-.52A2,2,0,0,0,114.77,155.83Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M115.51,156.18a2,2,0,0,0,.91-1.57.77.77,0,0,0-.11-.42.61.61,0,0,1,.28.59,2,2,0,0,1-.91,1.57c-.35.21-.65.15-.81-.1A.66.66,0,0,0,115.51,156.18Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.33,158.4a1.38,1.38,0,0,1,.62-1.07.43.43,0,0,1,.43-.05h0l.4.22,0,.07a.66.66,0,0,1,0,.21,1.38,1.38,0,0,1-.62,1.07.64.64,0,0,1-.2.08l0,.08-.38-.2A.43.43,0,0,1,114.33,158.4Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M114.71,158.6c0,.4.28.55.62.36a1.36,1.36,0,0,0,.62-1.07c0-.4-.27-.55-.62-.36A1.38,1.38,0,0,0,114.71,158.6Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114.73,158.61c0,.39.28.55.62.35a1.35,1.35,0,0,0,.62-1.07c0-.39-.28-.55-.62-.35A1.38,1.38,0,0,0,114.73,158.61Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.83,110c.36.07,1.08.14,1,1.57a23.13,23.13,0,0,0,.14,4.88c.09.64.55,1.16.36,1.52s-.73.12-.89-.23a8.17,8.17,0,0,1-.33-1,6.18,6.18,0,0,0,.24,1.93c.25.4.73.83.46,1.22s-1-.32-1.18-.77a5.16,5.16,0,0,1-.28-1,8.82,8.82,0,0,0,.26,1.84c.14.52.78,1.24.53,1.46s-.73,0-1.06-.61a2.76,2.76,0,0,1-.25-.58,6.53,6.53,0,0,1,.13,1.57c-.11.2-.62.41-.84-.32a46.88,46.88,0,0,1-1.15-7.87,6.94,6.94,0,0,1,.62-3C219.85,110.09,220.87,109.8,221.83,110Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.37,119.59c.65.16.88.17.92.9a24,24,0,0,1,0,4.07,21.88,21.88,0,0,1-1.35,5c-.36.47-.63.32-.73.21s0-.51,0-.78c.12-.76.22-1.84.22-1.84l-.66,2.61c-.15.6-.47,1.22-.86,1.25s-.51-.19-.45-.48a9.68,9.68,0,0,0,.25-1.31c.05-.4.13-1.47.13-1.47a19.34,19.34,0,0,1-.61,2.59c-.14.4-.57,1.82-1.24,1.45-.41-.23,0-1.19.22-2.05a18.5,18.5,0,0,0,.45-4.46c-.13-.86-.38-1.23-1.29-.58s-1.72,1.28-1.9.86.52-1.42,1.07-1.94,1.38-1.08,2-1.56c1.23-1,1.45-2.23,2-2.5A2.51,2.51,0,0,1,244.37,119.59Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M241,130.3l0,.09c-.36,1.07-.61,1.23-.73,1.23l-.09,0c-.11-.06.08-.72.17-1s.13-.48.18-.72a18.52,18.52,0,0,0,.46-4.56c-.07-.4-.17-1.06-.75-1.06a1.47,1.47,0,0,0-1,.3l-.27.19a4.46,4.46,0,0,1-1.27.76,3.33,3.33,0,0,1,1.05-1.62c.61-.59,1.5-1.18,1.95-1.54a5.9,5.9,0,0,0,1.41-1.77c.2-.33.16,0,1,.63a2.81,2.81,0,0,0,1,.3,24.42,24.42,0,0,1-1,2.5A43.58,43.58,0,0,0,241,130.3Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.5,119.7a1.4,1.4,0,0,0,2.79.23,1.4,1.4,0,0,0-2.79-.23Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.21,103s.8,0,1.24,1.37-.62,12.27-.79,13.36-.38,2.44-1.72,2.39a1.49,1.49,0,0,1-1.61-1.64c.06-1,.13-6.27-.1-9.44-.22-2.92-.25-3.83.17-4.79A2.32,2.32,0,0,1,245.21,103Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M244,105.74c.87.1.91.19.93,1.19.05,2.28-.37,9.17-.5,10.09s-.21,2.46-1,2.36c-.56-.07-.54-1.18-.56-1.83,0-1.32,0-5-.07-7.64-.1-2.45-.28-3.6,0-4.11C243,105.5,243.39,105.66,244,105.74Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.72,103.94a1.6,1.6,0,1,0,1.2-1.91A1.6,1.6,0,0,0,242.72,103.94Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.89,101.68c0,1.25-.29,1.8-1.72,2.13-1,.23-1.78,0-2-.82-.52-1.64-1.12-4.13-1.63-5.57-.56-1.59-1.43-2.68-.75-3.55s3.14-2.61,4.22-2.08S245.87,100.67,245.89,101.68Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M244.14,101.43c.13.8.21,1.68-.34,1.85a1,1,0,0,1-1.26-.76c-.18-.74-1-3.73-1.45-5s-1.05-2.66-.76-3.36,1.19-1.56,1.91-1.14S244.05,100.82,244.14,101.43Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.84,110.31a1.28,1.28,0,0,0,1.44,1.12,1.29,1.29,0,1,0-1.44-1.12Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.16,100.41c-.12,1.4-.83,4.45-1.12,6a19.55,19.55,0,0,0-.6,2.91c0,.85-.49,1.54-1.73,1.22s-1-1.49-1-2.51c0-2.38.18-8.74,1-10.77C221.23,96.07,224.48,96.78,224.16,100.41Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M222.07,101.19c-.13,1.2-.89,6.34-1,7.18s-.24,1.94-.66,1.53a3.14,3.14,0,0,1-.41-2.25,82.54,82.54,0,0,1,1-8.88C221.11,98.32,222.4,98.08,222.07,101.19Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M221.93,98.47a1.6,1.6,0,1,0-.65-2.17A1.61,1.61,0,0,0,221.93,98.47Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.71,89c.94.68,2.71-1.5,3.4-2.44a2.11,2.11,0,0,0-3.42-2.47C223,85,222.77,88.29,223.71,89Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.72,85.65c.68-.49,3.71,1.51,4,2.12s-.75,3.71-1.41,6c-.74,2.55-.88,3.3-1.91,3.43a1.81,1.81,0,0,1-2-.92C221,94.88,221.88,86.26,222.72,85.65Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M222.86,86.61a.94.94,0,0,1,1.49.35c.22.46-.36,3.08-.78,6.24-.33,2.4-.18,2.32-.58,2.89-.55.8-1.09.06-1.19-.33C221.49,94.66,222.18,87.3,222.86,86.61Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.76,144.21a2.4,2.4,0,0,1,1.59,2c.18,1.11.07,2.5-1.66,2.61a6.31,6.31,0,0,0-3.75,1.12c-1,.75-4.13,1.22-4.88.36s.33-1.44,1.24-2a13.29,13.29,0,0,0,3.35-2.67,3.19,3.19,0,0,1,1.95-1.35A3.89,3.89,0,0,1,230.76,144.21Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.35,146.17a2,2,0,0,0,0-.24c.11,1.06-.1,2.25-1.69,2.35a6.34,6.34,0,0,0-3.76,1.13c-1,.75-4.13,1.21-4.88.35a1.28,1.28,0,0,1-.14-.21.8.8,0,0,0,.23.71c.75.86,3.89.39,4.88-.36a6.31,6.31,0,0,1,3.75-1.12C232.42,148.67,232.53,147.28,232.35,146.17Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M229.46,145.64c1,.23,1.33-.21,1.47.61s0,1.42-1.24,1.5a4.62,4.62,0,0,0-2.78.84c-.74.55-4,1.81-4.47,1.11-.35-.5,1.07-1.22,1.74-1.63a9.92,9.92,0,0,0,2.49-2,2.4,2.4,0,0,1,1.45-1C228.38,145,228.59,145.43,229.46,145.64Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M229,128.1c.45.75.62,2.51,1.06,4.63s1.44,5,1.28,7.73.46,4.28.07,4.7a1.58,1.58,0,0,1-1.88.16c-.66-.4-1.1-.69-.93-1.08s1-1.88.31-5.13-1.76-7.59-2.14-8-.82-.29-1.28-1S228.16,126.77,229,128.1Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.75,143.41c-.51.61-2.59.17-3-.27s-1.39-5.47-2.21-8.31c-.74-2.54-1.64-4.65-1.27-5.23s2-2.76,3.62-2,2,4.77,2.42,7.43S232.26,142.8,231.75,143.41Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M230.08,142.84c-.24.55-.81.33-1.06,0s-1.17-4.34-1.78-6.79c-.54-2.2-1.23-4.19-1.06-4.71.09-.3.43-.16,1.09-.28a.88.88,0,0,1,1,.67c.55,2.69.78,4.05,1.33,6.86C230,140.85,230.32,142.28,230.08,142.84Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.33,148.26a3.2,3.2,0,0,1,.75,3.16,11.27,11.27,0,0,1-2.18,3.73c-.86.81-1.94,2-3.82,1.37s-.16-3.43.4-4.13a7.48,7.48,0,0,0,1.41-2.85c.15-.95.57-1.15,1.08-1.19S237.83,147.69,238.33,148.26Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.9,149.13a2.86,2.86,0,0,1,0,1.85,11.47,11.47,0,0,1-2.19,3.73c-.86.82-1.94,2-3.82,1.37a1.27,1.27,0,0,1-.64-.49,1.17,1.17,0,0,0,.82.93c1.88.68,3-.56,3.82-1.37a11.27,11.27,0,0,0,2.18-3.73A2.93,2.93,0,0,0,238.9,149.13Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M237.13,149.61c1-.08,1.1,0,1.24.32.25.52-.08.68-.3,1.25a11.33,11.33,0,0,1-1.91,2.94c-.94,1-1.78,1.84-2.93,1.52-1.37-.38.19-2.58.67-3.14a5.5,5.5,0,0,0,1.24-2.24c.13-.75.17-1,.61-1.06S236.1,149.7,237.13,149.61Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.13,133.21a16.22,16.22,0,0,1,1,5.38c.11,2.59,0,6.43-.07,7.56a13,13,0,0,0,.2,2.09,1.19,1.19,0,0,1-1.52,1.11c-1-.31-1.59-.93-1.39-1.5a15.22,15.22,0,0,0,.51-6.32,27.2,27.2,0,0,0-1.22-6c-.22-.33-.75-.73-.92-1.17S236.19,130.76,237.13,133.21Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.54,146.39a1,1,0,0,1-.86,1,3,3,0,0,1-2.31-.45c-.45-.55-1.08-5.66-1.47-8-.34-2-1.26-4.13-.34-4.74s2.13-2.27,3.65-1.66c.9.36,1.45,4.86,1.46,9.26C238.68,143.64,238.59,145.46,238.54,146.39Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.86,146.47a.73.73,0,0,1-1.23,0c-.24-.44-.89-5.18-1.22-7.5-.23-1.58-.83-3.84-.2-3.59a5.65,5.65,0,0,0,1.56.39c.54.09.29,2.73.55,5.54C236.51,143.44,236.86,146.47,236.86,146.47Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.9,128.5a2,2,0,1,0,2-2A2,2,0,0,0,224.9,128.5Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.76,127a2.48,2.48,0,0,1-2.36,2.36c-1.41,0-2.05-.63-2.23-2.36-.1-.94,1.06-19.72,1.76-21.67s2.71-4.06,5.36-2.88,2.71,4.36,1.53,7.12a55.76,55.76,0,0,0-2.94,10C229.52,121.71,228.76,125.71,228.76,127Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.35,111.7a5.93,5.93,0,0,1-4.12-4.77c-.26-1.51-.94-10-.94-10s10,.47,10.53,1.12-.27,4.17,1.09,7.79C239.08,108.91,234,112.59,231.35,111.7Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M228.37,110.34a6,6,0,0,1-1.69-3.29c0-.19-.07-.48-.11-.84a13,13,0,0,0-.55,1.93c-.36,1.69-1.22,17.4-1.19,18.22s.13,2,.86,2,.72-2.59.72-3.47c0-1.08.4-4.58.58-6.53A76.44,76.44,0,0,1,228.37,110.34Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.35,81.7c-1,0-3.27.12-3.92,1.62s.65,3.92.65,3.92-1.12,2.62-.68,4.47a7.53,7.53,0,0,1,.41,2.3c0,.18-1,3.09-.17,3.27a5.44,5.44,0,0,1,1.7.26c.62.3.94,1.1,2,1.83,1.27.85,6.14,3,7.44,3,3-.15,3.89-3.94,4.66-6.24.64-1.93,1.2-4.62,1.2-4.62s1.92-.3,1.86-1.62-1.67-2.42-3.2-3.71a25.06,25.06,0,0,0-4-2.94C232.83,81.44,230.17,81.76,228.35,81.7Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M228.68,82.11c-.91,0-3,.11-3.55,1.47a3.3,3.3,0,0,0,0,2A5.32,5.32,0,0,1,225,88.8a6.71,6.71,0,0,0-.41,2A6.36,6.36,0,0,0,225,93.2a22.22,22.22,0,0,0,4.4,2.2c3,.92,5.65-.16,6.46-2.2,1.53-3.85,4.09-3.57,4.56-4.74s.19-1.61-1.23-2.75A15.59,15.59,0,0,0,228.68,82.11Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.78,132.85a2,2,0,1,0,2-2A2,2,0,0,0,232.78,132.85Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.59,132.93a5,5,0,0,1-3.71.12,1.85,1.85,0,0,1-1.17-2.06,85.58,85.58,0,0,0,.46-10c-.11-4.65-1.09-8.34,0-11.13s3.69-4.87,6-4.17,2.91,3.29,2.67,6.17c-.28,3.35-3.91,13-4,15.91S237.33,132.43,236.59,132.93Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M234.56,132.08a1.06,1.06,0,0,1-1.71.35,1.72,1.72,0,0,1-.51-1.76c0-.31.47-5.3.4-9.77s-.66-7.29,0-10,2.36-4.71,3.85-4c1.17.54-.79,4.68-.94,7.44-.17,3.22-.75,10.3-.79,13.07S234.9,131.5,234.56,132.08Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233.94,71.05a3.53,3.53,0,0,1,1.5,4.68,10.08,10.08,0,0,0-.87,5.1,7.71,7.71,0,0,0,.9,2.54.6.6,0,0,1-.22.81,6,6,0,0,1-5.38.19.92.92,0,0,1-.41-1,11.94,11.94,0,0,0,.31-2.31C229.89,76.67,230.19,69.06,233.94,71.05Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.35,78a3.37,3.37,0,0,1-1.59,2.77c-1.18.8-3.27,2.33-4.62,1.59s-1.79-4.7-1.82-6.12c0-1.59.44-4.46,2.24-5.49a4.29,4.29,0,0,1,3.55-.46,5.65,5.65,0,0,1,2.3,1.5c.5.5,0,2-.26,3.06A12,12,0,0,0,234.35,78Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M228.18,80.89c-.81-.62-1.13-3.65-1.14-4.76s.31-3.35,1.32-4.29a2.4,2.4,0,0,1,2.42-.81c.6.21.37.88.21,1.35a19.18,19.18,0,0,0-.74,3.1C230.09,76.88,229.69,82.07,228.18,80.89Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M235.82,102.34c-1.3.06-6.17-2.12-7.44-3-1.1-.73-1.42-1.53-2-1.83a5.44,5.44,0,0,0-1.7-.26c-.8-.18.14-3.09.17-3.27a.13.13,0,0,0,0-.06h0v-.08h0a2.37,2.37,0,0,0,0-.24l.85.47a19.46,19.46,0,0,0,5.27,2.17c2.41.56,4.07.13,5.53-2.66,1-2,3.89-1.72,5.21-2h0c-.1.44-.61,2.8-1.19,4.54C239.71,98.4,238.86,102.19,235.82,102.34Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M228.17,96.68a28.05,28.05,0,0,1-3.57-1.87c.11-.42.2-.75.21-.8a1.11,1.11,0,0,0,0-.38l.85.47a19.46,19.46,0,0,0,5.27,2.17c2.41.56,4.3.17,5.76-2.62,1-2,3.66-1.76,5-2.09-.1.44-.61,2.8-1.19,4.54s-1.13,4-2.5,5.29a4.79,4.79,0,0,1-.2-1.63A7.84,7.84,0,0,0,237,95.4S235.33,100.41,228.17,96.68Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M243.05,90.93a5,5,0,0,1-2.23.69c-.69,0-1.61.29-1.68.93s1,.93,1.31,3.85,1.44,1.66,2.25-.38S243.44,91.52,243.05,90.93Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M231.91,79c.26-2.14-.8-6,.82-7.06a1.71,1.71,0,0,1,1.72-.12c.43.54-.07,2-.3,3a12,12,0,0,0,.2,3.15,3.37,3.37,0,0,1-1.59,2.77,10,10,0,0,1-3.36,1.74A5.25,5.25,0,0,0,231.91,79Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M221.41,117.71a32.74,32.74,0,0,1,.54-3.66c.14-.34.61-.41.91-.51a14.61,14.61,0,0,1,0-2h0c.06-1.43-.43.16-1.59.16-1.39,0-1.32-.78-1.49-.39s.53,1.87.62,4.63a9.7,9.7,0,0,0,.12,2.06C220.67,118.36,221.32,118.21,221.41,117.71Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M232.75,79.13A2.77,2.77,0,0,1,234,77a.91.91,0,0,1,.87-.1h0l.81.44-.09.16a1.09,1.09,0,0,1,.07.42A2.75,2.75,0,0,1,234.4,80a1.45,1.45,0,0,1-.4.16l-.09.16-.76-.4A.87.87,0,0,1,232.75,79.13Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M233.55,79.56c0,.79.56,1.11,1.25.71a2.77,2.77,0,0,0,1.25-2.16c0-.8-.56-1.12-1.25-.72A2.77,2.77,0,0,0,233.55,79.56Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M231.32,104.93a2.91,2.91,0,0,0-1.32-2.28.94.94,0,0,0-.91-.11h0l-.86.46.09.16a1.52,1.52,0,0,0-.07.45,2.92,2.92,0,0,0,1.33,2.28,1.37,1.37,0,0,0,.43.17l.09.16.8-.42A.9.9,0,0,0,231.32,104.93Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M230.51,105.36c0,.84-.59,1.18-1.32.76a2.93,2.93,0,0,1-1.33-2.29c0-.83.6-1.17,1.33-.75A2.91,2.91,0,0,1,230.51,105.36Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M230.48,105.38c0,.84-.59,1.18-1.32.75a2.92,2.92,0,0,1-1.33-2.28c0-.84.6-1.18,1.33-.75A2.91,2.91,0,0,1,230.48,105.38Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M230.07,105.14c0,.58-.41.81-.91.52a2,2,0,0,1-.91-1.57c0-.58.41-.81.91-.52A2,2,0,0,1,230.07,105.14Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M229.33,105.48a2,2,0,0,1-.91-1.57.73.73,0,0,1,.11-.41.62.62,0,0,0-.28.59,2,2,0,0,0,.91,1.57c.35.2.65.15.81-.11A.64.64,0,0,1,229.33,105.48Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M230.51,107.71a1.35,1.35,0,0,0-.62-1.07.43.43,0,0,0-.43,0h0l-.4.21,0,.08a.66.66,0,0,0,0,.21,1.38,1.38,0,0,0,.62,1.07.6.6,0,0,0,.2.07l.05.08.37-.2A.41.41,0,0,0,230.51,107.71Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M230.13,107.91c0,.39-.28.55-.62.35a1.33,1.33,0,0,1-.62-1.07c0-.39.27-.55.62-.35A1.38,1.38,0,0,1,230.13,107.91Z",
    transform: "translate(-67.79 -70.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M230.11,107.92c0,.39-.27.55-.62.35a1.38,1.38,0,0,1-.62-1.07c0-.39.28-.55.62-.35A1.34,1.34,0,0,1,230.11,107.92Z",
    transform: "translate(-67.79 -70.09)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerSperation);
export default __webpack_public_path__ + "static/media/speaker-speration.a0cf3b69eeff8ba1978d0574b716d00c.svg";
export { ForwardRef as ReactComponent };